<template>
  <card>
    <h4>Quick Setup</h4>
    <p style="font-size: 14px; color: #2e3646cc">
      Apply a predefined role template or build a custom role from scratch.
    </p>
    <div>
      <dropdown-button title="Apply a Preset" :buttonStyle="{width: '200px'}">
        <template #menu>
          <div
            v-for="(option, index) in options"
            :key="index"
            class="p-3 custom-role-option"
          >
            <div class="option-title">{{ option.title }}</div>
            <p class="m-0">{{ option.description }}</p>
          </div>
          
        </template>
      </dropdown-button>
    </div>
    <card v-if="showAddRole" className="bg-grey mt-4">
      <input-text
        placeholder="What's a cool name you'd want to call your role? e.g., Sales Manager, Content Editor..."
        :value="presetValue"
        label="Custom Role Name *"
        id="role-name"
        :error="errorAddRole"
      />
      <div class="d-flex mt-2" style="gap: 10px">
        <custom-button color="ghost" @click="handleCancel" variant="outlined">Cancel</custom-button>
        <custom-button>Create Role</custom-button>
      </div>
    </card>
  </card>
</template>

<script>
import { Card } from "../../../Layout";
import { SingleSelect, InputText } from "../../../Input";
import { CustomButton, DropdownButton } from "../../../Button";

export default {
  name: "QuickSetup",
  components: { Card, SingleSelect, InputText, CustomButton, DropdownButton },
  data() {
    return {
      presetValue: "",
      newPresetValue: "",
      errorAddRole: "",
      showAddRole: false,
      options: [
        {
          value: "admin",
          title: "Admin",
          description: "Full access to all settings and data.",
        },
        {
          value: "employee",
          title: "Employee",
          description: "Limited access to essential features.",
        },
        {
          value: "custom",
          title: "Custom Role",
          description: "Create a role with specific permissions.",
        },
      ],
    };
  },
  methods: {
    handleCancel() {
      this.showAddRole = false;
      this.presetValue = "";
      this.errorAddRole = "";
    },
  },
};
</script>

<style scoped>

.bg-grey {
  background-color: #f8f9fa;
}

.custom-role-option {
  padding-top: 4px;
  background: #f4f4f5;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.custom-role-option .option-title {
  color: #247fec;
  font-weight: 600;
  font-size: 14px;
}

.custom-role-option p {
  color: #2e3646cc;
  font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/Employee/Components/RolesAndPermissions/QuickSetup.vue